(function(){
  function setupOffer(root){
    if(!root || root.dataset.sb1Ready==='1')return;
    root.dataset.sb1Ready='1';
    var pinInput=root.querySelector('[id^="sb1-pin-"]');
    var feedback=root.querySelector('[data-sb1-pin-feedback]');
    var error=root.querySelector('[data-sb1-error]');
    var raw=root.getAttribute('data-allowed-pins')||'';
    var pins=raw.split(/[\s,;]+/).map(function(v){return v.trim();}).filter(Boolean);
    function msg(key,fallback){return root.getAttribute('data-'+key)||fallback;}
    function checkPin(){
      if(!pinInput)return true;
      var pin=pinInput.value.trim();
      if(!/^\d{6}$/.test(pin)){feedback.textContent=msg('pin-invalid','Enter a valid 6-digit PIN code.');feedback.style.color='#b42318';return false;}
      if(pins.length && pins.indexOf(pin)===-1){feedback.textContent=msg('pin-unavailable','Sorry, delivery is not available for this PIN code.');feedback.style.color='#b42318';return false;}
      feedback.textContent=pins.length?msg('pin-available','Delivery is available for this PIN code.'):msg('pin-format-only','PIN code format confirmed. Delivery availability will be checked at checkout.');
      feedback.style.color='#047d23';return true;
    }
    if(pinInput){pinInput.addEventListener('input',function(){feedback.textContent='';});var check=root.querySelector('[data-sb1-check-pin]');if(check)check.addEventListener('click',checkPin);}
    var buy=root.querySelector('[data-sb1-buy]');
    if(buy)buy.addEventListener('click',function(){
      if(error)error.textContent='';var id=root.getAttribute('data-variant-id');
      if(!id){if(error)error.textContent=msg('checkout-missing','Select a trial product in Theme Editor.');return;}
      if(pinInput&&!checkPin()){pinInput.focus();return;}
      var base=root.getAttribute('data-checkout-base')||'/';if(base.charAt(base.length-1)!=='/')base+='/';
      window.location.assign(base+'cart/'+encodeURIComponent(id)+':1?checkout');
    });
  }
  function setupReviews(root){
    if(!root||root.dataset.sb1ReviewsReady==='1')return;root.dataset.sb1ReviewsReady='1';
    var scroller=root.querySelector('[data-sb1-reviews]');if(!scroller)return;
    function move(dir){var card=scroller.querySelector('.sb1__review');if(card)scroller.scrollBy({left:dir*(card.getBoundingClientRect().width+16),behavior:'smooth'});}
    var prev=root.querySelector('[data-sb1-prev]'),next=root.querySelector('[data-sb1-next]');
    if(prev)prev.addEventListener('click',function(){move(-1);});if(next)next.addEventListener('click',function(){move(1);});
  }
  function setupFaqs(root){
    if(!root||root.dataset.sb1FaqsReady==='1')return;root.dataset.sb1FaqsReady='1';
    root.querySelectorAll('.sb1__faq').forEach(function(item){item.addEventListener('toggle',function(){if(!item.open)return;root.querySelectorAll('.sb1__faq').forEach(function(other){if(other!==item)other.open=false;});});});
  }
  function init(context){
    (context||document).querySelectorAll('[data-sb-one-day]').forEach(setupOffer);
    (context||document).querySelectorAll('[data-sb-one-day-reviews]').forEach(setupReviews);
    (context||document).querySelectorAll('[data-sb-one-day-faqs]').forEach(setupFaqs);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  if(!window.sb1ModularEditorBound){window.sb1ModularEditorBound=true;document.addEventListener('shopify:section:load',function(e){init(e.target);});}
})();
